import React, { useState, useRef, useEffect } from 'react';
import './MusicPlayer.css';

const MusicPlayer = () => {
  const [isPlaying, setIsPlaying] = useState(false); // Will be set to true in useEffect
  const [volume, setVolume] = useState(0.5); // Set default volume to middle (0.5)
  const [showVolumeSlider, setShowVolumeSlider] = useState(false);
  const audioRef = useRef(null);

  useEffect(() => {
    const audio = audioRef.current;
    if (audio) {
      audio.volume = volume;
      audio.loop = true;
      
      // Attempt to play audio automatically
      const playPromise = audio.play();
      if (playPromise !== undefined) {
        playPromise
          .then(() => {
            setIsPlaying(true); // Set playing state if autoplay succeeds
          })
          .catch(error => {
            console.log('Audio autoplay blocked:', error);
            // Autoplay was prevented, keep isPlaying as false
            // User will need to click to start
          });
      }
    }
  }, [volume]); // Depend on volume to update audio.volume if it changes

  const toggleMusic = () => {
    const audio = audioRef.current;
    if (audio) {
      if (isPlaying) {
        audio.pause();
        setIsPlaying(false);
      } else {
        // Handle browser autoplay policies
        const playPromise = audio.play();
        if (playPromise !== undefined) {
          playPromise
            .then(() => {
              setIsPlaying(true);
            })
            .catch(error => {
              console.log('Audio play failed:', error);
              // Show user-friendly message if autoplay is blocked
              if (error.name === 'NotAllowedError') {
                alert('Please click the play button to start the background music.');
              }
            });
        }
      }
    }
  };

  const handleVolumeChange = (e) => {
    const newVolume = parseFloat(e.target.value);
    setVolume(newVolume);
    if (audioRef.current) {
      audioRef.current.volume = newVolume;
    }
  };

  return (
    <div className="music-player">
      <audio ref={audioRef} src="/Bg-music.wav" preload="auto" />
      
      <div className="music-controls">
        <button 
          className={`music-toggle ${isPlaying ? 'playing' : ''}`}
          onClick={toggleMusic}
          aria-label={isPlaying ? 'Pause music' : 'Play music'}
        >
          <div className="music-icon">
            {isPlaying ? (
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M6 4h4v16H6V4zm8 0h4v16h-4V4z"/>
              </svg>
            ) : (
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M8 5v14l11-7z"/>
              </svg>
            )}
          </div>
        </button>
        
        <div 
          className={`volume-control ${showVolumeSlider ? 'show' : ''}`}
          onMouseEnter={() => setShowVolumeSlider(true)}
          onMouseLeave={() => setShowVolumeSlider(false)}
        >
          <div className="volume-slider">
            <input
              type="range"
              min="0"
              max="1"
              step="0.1"
              value={volume}
              onChange={handleVolumeChange}
              className="volume-range"
              aria-label="Volume control"
            />
            <div className="volume-level" style={{ height: `${volume * 100}%` }}></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MusicPlayer; 